'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function () {
    function Footer(module) {
        (0, _classCallCheck3.default)(this, Footer);


        // Caching the module element.
        this.module = module;

        // Caching the button that opens the overlay.
        this.links = this.module.querySelectorAll('.footer--link');

        // Caching a reference to the body element.
        this.body = document.querySelector('body');

        // Caching the modal element.
        this.modal = document.querySelector('#modal');
    }

    // Initializes event bindings.


    Footer.prototype.init = function init() {
        var _this = this;

        // Find the links that only open modals in the footer nav.
        for (var i = 0, count = this.links.length; i < count; i++) {
            if (this.links[i].hasAttribute('data-modal')) {
                (function () {
                    var modalID = _this.links[i].getAttribute('data-modal'); // eslint-disable-line no-unused-vars
                    _this.links[i].onclick = function () {
                        return _this.open(modalID);
                    };
                })();
            }
        }

        // GA Tracking events
        document.querySelector('#vince-nav').onclick = function () {
            return _this.trackEvent('Vince Mcmohan', 'Nav', 'click', 'vince');
        };
        document.querySelector('#contact-nav').onclick = function () {
            return _this.trackEvent('Contact', 'Nav', 'click', 'contact');
        };
        document.querySelector('#contact--cta').onclick = function () {
            return _this.trackEvent('Contact Us', 'Body', 'click', 'contactus');
        };
        document.querySelector('#facebook-share').onclick = function () {
            return _this.trackEvent('Facebook', 'Footer', 'click', 'FB');
        };
        document.querySelector('#twitter-share').onclick = function () {
            return _this.trackEvent('Twitter', 'Footer', 'click', 'TW');
        };
        document.querySelector('#instagram-share').onclick = function () {
            return _this.trackEvent('Instagram', 'Footer', 'click', 'IG');
        };
        document.querySelector('#youtube-share').onclick = function () {
            return _this.trackEvent('Youtube', 'Footer', 'click', 'YT');
        };
        document.querySelector('#contact-email').onclick = function () {
            return _this.trackEvent('Contact Email', 'Body', 'click', 'contactemail');
        };
        document.querySelector('#vincearrow').onclick = function () {
            return _this.trackEvent('Vince down arrow', 'Body', 'click', 'vincearrow');
        };
        document.querySelector('#vod-nav').onclick = function () {
            return _this.trackEvent('Watch Video', 'Nav', 'click', 'video');
        };
    };

    // Opens the vince modal.


    Footer.prototype.open = function open(name) {
        var view = this.modal.querySelector('.modal--wrap[data-name="' + name + '"]'); // eslint-disable-line prefer-template
        if (view !== null) {
            view.setAttribute('aria-hidden', 'false');
            this.modal.setAttribute('aria-hidden', 'false');
            this.body.setAttribute('data-scroll-pos', window.scrollY);
            this.body.setAttribute('data-scrollable', 'false');

            if (name === 'terms') {
                this.trackEvent('Terms and Conditions', 'Footer', 'click', 'terms');
            }
            if (name === 'privacy') {
                this.trackEvent('Privacy Policy', 'Footer', 'click', 'privacypolicy');
            }
        }
    };

    Footer.prototype.trackEvent = function trackEvent(name, category, action, label) {
        // Send tracking event
        gtag('event', name, { // eslint-disable-line
            'event_category': category, // eslint-disable-line
            'event_action': action, // eslint-disable-line
            'event_label': label // eslint-disable-line
        }); // eslint-disable-line
    };

    return Footer;
}();

var _module = document.querySelector('.footer');
if (_module !== null) {
    var footer = new Footer(_module);
    footer.init();
}


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.js
// module id = 1
// module chunks = 0